import { useState } from 'react';
import { CountDownCardTimer } from '../CountdownCard/CountDownCardTimer';
import { CountDownCardImage } from '../CountdownCard/CountDownCardImage';

export interface ICountdownVestingProps {
  endDate: string;
  countdownVestingIndex: number;
}
export const CountdownVesting = ({
  endDate,
  countdownVestingIndex
}: ICountdownVestingProps) => {
  const [partyTime, setPartyTime] = useState(false);

  const handlerPartyTime = () => {
    setPartyTime(true);
  };
  return (
    <>
      {partyTime ? (
        <CountDownCardImage index={countdownVestingIndex} />
      ) : (
        <CountDownCardTimer
          index={countdownVestingIndex}
          onPartyTime={handlerPartyTime}
          endDate={endDate}
        />
      )}
    </>
  );
};
